export function getDefaultGitVersion() {
  return { dirty: false, raw: '', hash: '', distance: null, tag: null, semver: null, suffix: '', semverString: null };
}
